import { ILoadingOverlayAngularComp } from 'ag-grid-angular';
import { ILoadingOverlayParams, IAfterGuiAttachedParams } from 'ag-grid-community';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'cv-angular-loading-overlay',
    templateUrl: './cv-angular-loading-overlay.component.html',
    styleUrls: ['./cv-angular-loading-overlay.component.scss']
})
export class CvAngularLoadingOverlayComponent implements ILoadingOverlayAngularComp {

    constructor() { }

    agInit(params: ILoadingOverlayParams) {

    }

    afterGuiAttached?(params?: IAfterGuiAttachedParams) {

    }
}
